import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Pressable } from "@-/com.npmjs.react-native";
import type { PinyinSoundButtonGate } from "#use-pinyin-sound-button-gate";

/**
 * The single onPress audio surface for pinyin playback. Renders a pressable
 * speaker icon that, when tapped, plays the card's pinyin audio. Audio is
 * NEVER triggered automatically by this component — every playback originates
 * from an explicit user press on this exact icon. Use this everywhere pinyin
 * audio should be playable; programmatic playback lives in
 * `routes/nav/app/learn/_lib/audio` and is gated to the learn layout.
 *
 * Only `usePinyinSoundButtonGate` decides whether it shows (the card must have bundled audio).
 */
export function PinyinSoundButton({
  className,
  gate,
  hitSlop = 8,
  iconClassName = "text-muted-foreground",
  mode = "single",
  size = 14,
}: {
  className?: string;
  gate: PinyinSoundButtonGate;
  hitSlop?: number;
  iconClassName?: string;
  /**
   * `single` plays just the selected pinyin (or the first study pinyin if
   * none is selected). `sequence` plays every study pinyin in order.
   */
  mode?: "single" | "sequence";
  size?: number;
}) {
  return (
    <Pressable
      className={className}
      hitSlop={hitSlop}
      onPress={() => {
        if (mode === "sequence") {
          void gate.playSequence();
          return;
        }
        void gate.play();
      }}
    >
      <Icon className={iconClassName} name="IoVolumeHighOutline" size={size} />
    </Pressable>
  );
}
